import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("theaaradhyaenterprise@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-col justify-between w-1/2 bg-[#0F2942] text-white p-12 relative overflow-hidden">
        <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-teal-500/10 blur-3xl" />
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-teal-500 flex items-center justify-center font-heading font-extrabold text-xl">P</div>
          <div><div className="font-heading font-bold">PRABHAT</div><div className="text-xs text-slate-400">Professional Consultancy Services</div></div>
        </div>
        <div>
          <h1 className="font-heading text-4xl font-extrabold leading-tight">Accounting & Finance<br />Management System</h1>
          <p className="text-slate-300 mt-4 max-w-md">Ledger-based accounting with candidate advances, agency payables, multi-account ledgers, reports and a complete audit trail.</p>
          <div className="flex gap-6 mt-8 text-sm text-slate-400">
            <div><div className="text-2xl font-bold font-mono text-teal-400">₹</div>INR / Indian FY</div>
            <div><div className="text-2xl font-bold font-mono text-teal-400">2</div>Branches</div>
            <div><div className="text-2xl font-bold font-mono text-teal-400">AI</div>Assistant</div>
          </div>
        </div>
        <div className="text-xs text-slate-500">Jamnagar · Porbandar · India</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 bg-slate-50 dark:bg-slate-950">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8 justify-center">
            <div className="h-10 w-10 rounded-xl bg-[#0F2942] flex items-center justify-center font-heading font-extrabold text-white">P</div>
            <span className="font-heading font-bold text-lg">PRABHAT</span>
          </div>
          <h2 className="font-heading text-2xl font-bold text-slate-900 dark:text-slate-100">Welcome back</h2>
          <p className="text-sm text-slate-500 mb-6">Sign in to your accounting dashboard</p>
          {error && <div className="mb-4 text-sm bg-rose-50 text-rose-700 border border-rose-200 rounded-lg px-3 py-2" data-testid="login-error">{error}</div>}
          <div className="space-y-4">
            <div><Label className="text-xs">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
            <div><Label className="text-xs">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" /></div>
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full mt-6 bg-[#0F2942] hover:bg-[#163a5c] h-11">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </Button>
          <p className="text-[11px] text-slate-400 mt-6 flex items-center gap-1.5 justify-center"><ShieldCheck className="h-3.5 w-3.5" /> Secure role-based access</p>
        </form>
      </div>
    </div>
  );
}
